var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.0502C0 1.69215 0.142232 1.34878 0.395406 1.0956C0.64858 0.842427 0.991958 0.700195 1.35 0.700195H16.65C17.008 0.700195 17.3514 0.842427 17.6046 1.0956C17.8578 1.34878 18 1.69215 18 2.0502V3.4002H0V2.0502Z",
    fill: "#3A476A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.2002V11.9502C0 12.3082 0.142232 12.6516 0.395406 12.9048C0.64858 13.158 0.991958 13.3002 1.35 13.3002H16.65C17.008 13.3002 17.3514 13.158 17.6046 12.9048C17.8578 12.6516 18 12.3082 18 11.9502V5.2002H0ZM6.3 8.8002H1.8V7.0002H6.3V8.8002Z",
    fill: "#3A476A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCredit);
export default __webpack_public_path__ + "static/media/debit-credit.65a98cc7bbb3aeb6af3ab71fad9baef7.svg";
export { ForwardRef as ReactComponent };